import React, { Component } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import ModalImage from 'react-modal-image';

import './section-gallery.scss';

//Images
import Tree1 from '../../../assets/img/services/tree_1.JPG';
import Tree2 from '../../../assets/img/services/tree_2.jpg';
import Tree3 from '../../../assets/img/services/tree_3.jpg';
import Tree4 from '../../../assets/img/services/tree_4.jpg';
import Tree5 from '../../../assets/img/services/tree_5.jpg';
import Tree6 from '../../../assets/img/services/tree_6.jpg';
import Tree7 from '../../../assets/img/services/tree_7.JPG';
import Tree8 from '../../../assets/img/services/tree_8.jpg';
import Tree9 from '../../../assets/img/services/tree_9.jpg';
import Tree10 from '../../../assets/img/services/tree_10.jpg';
import Tree11 from '../../../assets/img/services/tree_11.JPG';
import Tree12 from '../../../assets/img/services/tree_12.jpg';
import Tree13 from '../../../assets/img/services/tree_13.jpg';
import Tree14 from '../../../assets/img/services/tree_14.jpg';
import Tree15 from '../../../assets/img/services/tree_15.jpg';
import Tree16 from '../../../assets/img/services/tree_16.jpg';
import Tree17 from '../../../assets/img/services/tree_17.jpg';
import Tree18 from '../../../assets/img/services/tree_18.jpg';
import Tree19 from '../../../assets/img/services/tree_19.jpg';
import Tree20 from '../../../assets/img/services/tree_20.jpg';
import Tree21 from '../../../assets/img/services/tree_21.jpg';
import Tree22 from '../../../assets/img/services/tree_22.jpg';
import Tree23 from '../../../assets/img/services/tree_23.jpeg';
import Tree24 from '../../../assets/img/services/tree_24.jpeg';
import Tree25 from '../../../assets/img/services/tree_25.jpeg';
import Tree26 from '../../../assets/img/services/tree_26.jpeg';
import Tree27 from '../../../assets/img/services/tree_27.jpeg';
import Tree28 from '../../../assets/img/services/tree_28.jpeg';

class SectionGallery extends Component {

    constructor(props){
        super(props);

        const imagesGallery = [
            { id: 1, src: Tree1 },
            { id: 2, src: Tree2 },
            { id: 3, src: Tree3 },
            { id: 4, src: Tree4 },
            { id: 5, src: Tree5 },
            { id: 6, src: Tree6 },
            { id: 7, src: Tree7 },
            { id: 8, src: Tree8 },
            { id: 9, src: Tree9 },
            { id: 10, src: Tree10 },
            { id: 11, src: Tree11 },
            { id: 12, src: Tree12 },
            { id: 13, src: Tree13 },
            { id: 14, src: Tree14 },
            { id: 15, src: Tree15 },
            { id: 16, src: Tree16 },
            { id: 17, src: Tree17 },
            { id: 18, src: Tree18 },
            { id: 19, src: Tree19 },
            { id: 20, src: Tree20 },
            { id: 21, src: Tree21 },
            { id: 22, src: Tree22 },
            { id: 23, src: Tree23 },
            { id: 24, src: Tree24 },
            { id: 25, src: Tree25 },
            { id: 26, src: Tree26 },
            { id: 27, src: Tree27 },
            { id: 28, src: Tree28 },
        ]

        this.state = {
            gallery: imagesGallery
        }
    }

    render(){

        let title = this.props.title;
        let images = this.state.gallery;
        return (
            <section className="section-gallery">
                <h1>
                    {title}
                </h1>
                <div>
                    <Container fluid={true}>
                        <Row className="padding-20 no-padding-top masonry-container">
                            {
                                images.map((img) => 
                                    <Col key={img.id} xs={6} md={4} lg={3} xl={2} >
                                        <ModalImage className="image-container"
                                            hideZoom={true}
                                            hideDownload={true}
                                            smallSrcSet={img.src}
                                            large={img.src}
                                            alt="ABC Tree Services"
                                        />
                                    </Col>
                                )
                            }
                        </Row>
                    </Container>
                </div>
            </section>
        )
            
    }
}

export default SectionGallery;